<template>
<b-tab :title="$t('USERINVOICES')" @click="getData()">
    <div>
        <div class="row mb-2">
            <div class="col-12">
                <button type="button" class="btn btn-primary button-add pull-right" @click="showModal()">{{$t('NEW')}}</button>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <loading v-if="isLoading" />
                <template v-if="!isLoading">
                    <p v-if="invoices.length === 0" class="text-muted">{{ $t('NODATAFOUND') }}</p>
                    <table v-else class="table table-sm table-bordered table-logoped">
                        <thead>
                            <tr>
                                <th>{{ $t('PROFILE_INVOICE_ISSUE_DATE') }}</th>
                                <th>{{ $t('PROFILE_INVOICE_AMOUNT') }}</th>
                                <th>{{ $t('PROFILE_INVOICE_PAYMENT_DATE') }}</th>
                                <th>{{ $t('ACTIONS') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="item in invoices"
                                :key="item.userInvoiceId"
                                :class="rowClass(item)">
                                <td>{{ formatDate(item.issueDate) }}</td>
                                <td>{{ formatAmount(item.amount) }}</td>
                                <td>{{ item.paymentDate ? formatDate(item.paymentDate) : $t('PROFILE_INVOICE_UNPAID') }}</td>
                                <td>
                                    <button type="button" class="btn button-edit mr-1" @click="showModal(item)">{{ $t('EDIT') }}</button>
                                    <button type="button" class="btn button-dlt" @click="deleteRow(item.userInvoiceId)">{{ $t('DELETE') }}</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </template>
            </div>
        </div>

        <b-modal ref="formmodal" :title="$t('USERINVOICESFORM')" ok-title="submit" hide-footer no-close-on-backdrop size="lg">
            <div class="d-block">
                <b-form-group :label="$t('PROFILE_INVOICE_ISSUE_DATE')">
                    <lb-vue-datetimepicker
                        type="date"
                        v-model="formData.issueDate"
                        :translate-method="translateDateTimePicker"
                        format="YYYY-MM-DD"
                        display-format="DD.MM.YYYY"
                        :simple="true">
                    </lb-vue-datetimepicker>
                </b-form-group>
                <b-form-group :label="$t('PROFILE_INVOICE_AMOUNT')">
                    <b-form-input v-model="formData.amount" type="number" step="0.01" />
                </b-form-group>
                <b-form-group :label="$t('PROFILE_INVOICE_PAYMENT_DATE')">
                    <lb-vue-datetimepicker
                        type="date"
                        v-model="formData.paymentDate"
                        :translate-method="translateDateTimePicker"
                        format="YYYY-MM-DD"
                        display-format="DD.MM.YYYY"
                        :simple="true">
                    </lb-vue-datetimepicker>
                </b-form-group>
            </div>
            <div class="text-right">
                <b-btn class="btn button-cancel mr-2" @click="hideModal()">{{ $t('CANCEL') }}</b-btn>
                <b-btn class="btn button-save" @click="submitData(formData)">{{ $t('SAVE') }}</b-btn>
            </div>
        </b-modal>
    </div>
</b-tab>
</template>

<script>
import moment from 'moment';
import Api from '@/api/user_invoices/UserInvoices';

export default
{
    name: 'UserInvoicesWin',
    props: ['childId'],
    data()
    {
        return {
            isLoading: false,
            invoices: [],
            formData:
            {
                userInvoiceId: null,
                issueDate: null,
                amount: null,
                paymentDate: null,
            },
            formError: {},
        };
    },
    methods:
    {
        async getData()
        {
            const me = this;
            me.isLoading = true;
            try
            {
                const data = await Api.selectRow({ childId: me.childId });
                if (data.error && data.error === true)
                {
                    me.$notify.notice(data);
                    return;
                }
                me.invoices = data.root;
            }
            catch (e)
            {
                me.$notify.notice(e);
            }
            finally
            {
                me.isLoading = false;
            }
        },
        translateDateTimePicker(val)
        {
            const me = this;
            return me.$t(val.toUpperCase());
        },
        async submitData(item)
        {
            const me = this;
            try
            {
                item.childId = me.childId;

                const isUpdate = item.userInvoiceId != null;
                let data;

                if (isUpdate)
                {
                    item.id = item.userInvoiceId;
                    if (item.paymentDate) item.paymentDate = moment(item.paymentDate).format('YYYY-MM-DD');
                    if (item.issueDate) item.issueDate = moment(item.issueDate).format('YYYY-MM-DD');
                    data = await Api.updateRow(item);
                }
                else
                {
                    data = await Api.insertRow(item);
                }

                if (data.error)
                {
                    me.$notify.notice(data);
                    me.formError = data;
                }
                else
                {
                    me.$notify.notice(data);
                    me.hideModal();
                    await me.getData();
                }
            }
            catch (e)
            {
                me.$notify.notice(e);
            }
        },
        deleteRow(id)
        {
            const me = this;
            me.$store.commit('setModalAlert',
                {
                    text: me.$i18n.t('AREYOUSHURE'),
                    async btnAction()
                    {
                        const data = await Api.deleteRow({ id, childId: me.childId });
                        me.$notify.notice(data);
                        await me.getData();
                    },
                });
        },
        showModal(item)
        {
            const me = this;
            if (item != null)
            {
                me.formData = { ...item };
            }
            me.$refs.formmodal.show();
        },
        hideModal()
        {
            const me = this;
            me.$refs.formmodal.hide();
            me.formData = {
                userInvoiceId: null,
                issueDate: null,
                amount: null,
                paymentDate: null,
            };
            me.formError = {};
        },
        rowClass(item)
        {
            if (item.paymentDate == null)
            {
                const days = moment().diff(moment(item.issueDate), 'days');
                return days > 7 ? 'table-danger' : 'table-warning';
            }
            const days = moment(item.paymentDate).diff(moment(item.issueDate), 'days');
            return days > 7 ? 'table-danger' : 'table-success';
        },
        formatDate(val)
        {
            return moment(val).format('DD.MM.YYYY');
        },
        formatAmount(val)
        {
            return parseFloat(val).toFixed(2);
        },
    },
};
</script>
